import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("ux-slider", () => {
    it("should match to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-slider>
                <ux-slider-slide>
                    <div>
                        <h1>Slide content</h1>
                    </div>
                </ux-slider-slide>
            </ux-slider>
            `
        );
        const el = await page.find("ux-slider");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should match to snapshot with more slides than are visbile", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-slider>
                ${[1, 2, 3, 4, 5, 6]
                    .map(
                        (number) =>
                            `<ux-slider-slide>
                            <p>Slide${number}</p>
                        </ux-slider-slide>`
                    )
                    .join("")}
            </ux-slider>
            `
        );
        const el = await page.find("ux-slider");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("Should change slide when navigation buttons or pagination is clicked", async () => {
        const page = await newE2EPage();
        await page.setContent(simpleTemplate());
        await page.waitForChanges();
        const uxSlider = await page.find("ux-slider");
        const firstSlide = await page.find("ux-slider-slide");
        const sliderButton = await page.find(".ux-slider-button-next");
        expect(uxSlider).toHaveClass("hydrated");
        expect(firstSlide).toHaveClass("ux-slider-slide-active");
        await sliderButton.click();
        await page.waitForChanges();
        expect(firstSlide).not.toHaveClass("ux-slider-slide-active");
        const activeSlide = await page.find(".ux-slider-slide-active");
        const paginationArrow = await page.find(".ux-slider-pagination__navigation-arrow--next");
        await paginationArrow.click();
        await page.waitForChanges();
        expect(activeSlide).not.toHaveClass("ux-slider-slide-active");
    });

    it("dispatches the correct events", async () => {
        const page = await newE2EPage();
        await page.setContent(simpleTemplate());
        await page.waitForChanges();
        await page.waitForSelector("ux-slider.hydrated");
        const paginationEvent = await page.spyOnEvent("uxSliderUpdatePagination");
        const sliderButton = await page.find(".ux-slider-button-next");
        await sliderButton.click();
        await page.waitForChanges();
        expect(paginationEvent).toHaveReceivedEvent();
    });

    it("should render valid html", async () => {
        await testValidHtml(
            `<ux-slider>
                <ux-slider-slide>
                    <div>
                        <h1>Slide content</h1>
                    </div>
                </ux-slider-slide>
            </ux-slider>`,
            [
                "element-permitted-content", // style inside div
                "no-redundant-role" // button role rendered by swiper
            ]
        );
    });
});

describe("slider pagination", () => {
    it("renders with bottom pagination", async () => {
        const page = await newE2EPage();
        await page.setContent(`
            <ux-slider>
                <ux-slider-slide>
                </ux-slider-slide>
                <ux-slider-pagination
                    slot="pagination"
                    bottom-pagination
                >
                </ux-slider-pagination>
            </ux-slider>`);
        const el = await page.find("ux-slider-pagination");
        await page.waitForChanges();
        expect(el).toHaveClass("ux-slider-pagination--bottom");
        expect(el).toHaveAttribute("slider-id");
    });

    it("renders with anchor pagination", async () => {
        const page = await newE2EPage();
        await page.setContent(`
            <ux-slider>
                <ux-slider-slide>
                    <div class="ux-slider-inline-pagination-anchor"></div>
                </ux-slider-slide>
                <ux-slider-pagination
                    slot="pagination"
                    anchor-pagination
                >
                </ux-slider-pagination>
            </ux-slider>`);
        const el = await page.find("ux-slider-pagination");
        await page.waitForChanges();
        expect(el).toHaveClass("ux-slider-pagination--anchor");
    });
});

function simpleTemplate() {
    return `
    <ux-slider>
        ${[1, 2, 3, 4, 5, 6]
            .map(
                (number) =>
                    `<ux-slider-slide>
                    <p>Slide${number}</p>
                </ux-slider-slide>`
            )
            .join("")}
        <ux-slider-pagination bottom-pagination slot="pagination">
        </ux-slider>
    </ux-slider>
    `;
}
